import { Validation } from './validation';

export const ValidationFileSize = (percent: number): Validation[] => [new Validation(
  (v) => (percent <= 100) || (percent === Infinity),
  '既にデータ容量制限値を超えています。',
)];
